/* eslint-disable */
// This file is automatically generated and should not be edited directly.
// Please edit the corresponding SVG file

import React from 'react';

const Bordspil = (props: any) => (
<svg {...props} xmlns="http://www.w3.org/2000/svg"   viewBox="0 0 24 24" stroke="none" fill="none">
  <path d="M2.0001 7.5C1.62057 12.8333 3.02509 22.5 13.5 22.5" stroke="#E5E8EF" strokeWidth="2" strokeLinecap="round"/>
  <path d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z" fill="#282828"/>
  <circle cx="12" cy="12" r="2.25" stroke="#282828" strokeWidth="1.5"/>
  <rect x="11.25" y="6" width="1.5" height="4" rx="0.75" fill="#282828"/>
  <rect x="18" y="11.25" width="1.5" height="4" rx="0.75" transform="rotate(90 18 11.25)" fill="#282828"/>
  <rect x="11.25" y="14" width="1.5" height="4" rx="0.75" fill="#282828"/>
  <rect x="10" y="11.25" width="1.5" height="4" rx="0.75" transform="rotate(90 10 11.25)" fill="#282828"/>
  <circle cx="12" cy="12" r="11.25" stroke="#282828" strokeWidth="1.5"/>
  <circle cx="12" cy="12" r="8.25" stroke="#282828" strokeWidth="1.5"/>
</svg>);

export default Bordspil;